import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "image-slot" }

import { PictureFilled } from '@element-plus/icons-vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DescriptionImage',
  props: {
    images: {},
    xl: { default: 4 },
    lg: { default: 4 },
    md: { default: 6 }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, { gutter: 12 }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (url) => {
        return (_openBlock(), _createBlock(_component_el_col, {
          key: url,
          xs: 12,
          sm: 12,
          md: _ctx.md,
          lg: _ctx.lg,
          xl: _ctx.xl
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_image, {
              fit: "cover",
              class: "image",
              src: url,
              "preview-src-list": _ctx.images
            }, {
              error: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_el_icon, { class: "image-slot-icon" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(PictureFilled))
                    ]),
                    _: 1
                  }),
                  _cache[0] || (_cache[0] = _createElementVNode("span", { class: "image-slot-text" }, "Image not available", -1))
                ])
              ]),
              _: 2
            }, 1032, ["src", "preview-src-list"])
          ]),
          _: 2
        }, 1032, ["md", "lg", "xl"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})